export default "__VITE_ASSET__CUjSG6m$__"